import { Component, OnInit } from '@angular/core';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { MultiSelectDropdownItem } from 'mis-crystal-design-system/multi-select-dropdown';
import { CommonService } from 'src/app/shared/services/common.service';
import { BookingsViewService } from '../bookings-view/bookings-view.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DefineCabsDialogComponent } from './define-cabs-dialog/define-cabs-dialog.component';

@Component({
  selector: 'app-dbva',
  templateUrl: './dbva.component.html',
  styleUrls: ['./dbva.component.scss']
})
export class DbvaComponent implements OnInit {

  searchInput = '';
  cities: DropdownItem[];
  citylist: any;
  firstCity = '';
  selectedCity = '';
  availableCabTypesList: any;
  vehicleDesignation: any;
  availableCabTypes: any;
  designationCabMap: any = new Map();
  filteredMap: Map<string, {selectedVehicles: string[], hasHighCapacityAccess: boolean}> = new Map();
  alteredList = [];
  alteredDesignationCabs = [];
  showSuccessToast = false;
  toastMsg: string;
  showSaveConfigWarning = false;
  isLoading: boolean  = true;
  dbvaFlavour: string;
  dialogRef: MatDialogRef<DefineCabsDialogComponent>

  constructor(private commonService: CommonService,
              private bookingViewService: BookingsViewService,
              public dialog: MatDialog,) { }

  ngOnInit(): void {
    this.dbvaFlavour = this.commonService.miscConfig?.DesignationBasedVehicleAllocation;

    this.commonService.fetchConfig().subscribe((response: any) => {
      this.citylist = response.pageConfigList[6].sectionConfigList[0].elementConfigList[3].config.values;
      this.cities = this.citylist.map((item: any) => ({
        label: item,
        value: item,
      })).filter((item) => {
        return item.label !== "All";
      }).sort(
        (a, b) => (a.label > b.label) ? 1 : (a.label < b.label) ? -1 : 0
      );
      this.firstCity = this.cities[0].label;
      this.bookingViewService.cityName.next(this.firstCity);
      this.bookingViewService.cityName.subscribe(res => this.selectedCity = res);
      this.setVehicleDesignationList();
    });
  }

  setVehicleDesignationList() {
    this.bookingViewService.fetchVehicleConfig(this.selectedCity).subscribe(res => {
      this.availableCabTypesList = res.availableCabTypes;
      this.vehicleDesignation = res.vehicleDesignation;
      this.availableCabTypes = this.availableCabTypesList.map((item: any) => ({
        label: item.cabType,
        value: item.cabType
      }));
      this.vehicleDesignation.forEach(item => {
        // this.designationCabMap.set(item.designation, item.selectVehicleTypes.map((item) => (
        //   {
        //     label: item,
        //     value: item
        //   }
        // )));
        // this.filteredMap = new Map(this.designationCabMap);
        this.designationCabMap.set(item.designation, 
          {
            selectedVehicles: item.selectVehicleTypes.map(item=> ({label: item, value: item})),
            hasHighCapacityAccess: item.hasHighCapacityAccess || false
          });
        this.filteredMap.set(item.designation,
          {
            selectedVehicles: item.selectVehicleTypes.map(item=> ({label: item, value: item})),
            hasHighCapacityAccess: item.hasHighCapacityAccess || false
          });
      });
      this.isLoading = false;
    });
  }

  selectedItems(values: any, designation: string) {
    this.alteredDesignationCabs = [];
    this.filteredMap.set(designation, 
      {
        selectedVehicles: values,
        hasHighCapacityAccess: this.filteredMap.get(designation).hasHighCapacityAccess 
      });
    this.filteredMap.get(designation).selectedVehicles.map((item: any) => this.alteredDesignationCabs.push(item.label));
    const index = this.alteredList.findIndex(element => element.designation == designation);
    if (index === -1) {
      this.alteredList.push({
        designation,
        selectVehicleTypes: this.alteredDesignationCabs,
        hasHighCapacityAccess: this.filteredMap.get(designation).hasHighCapacityAccess
      });
    }
    else {
      this.alteredList[index].selectVehicleTypes = this.alteredDesignationCabs;
    }
  }

  onSearchInputChange(input) {
    this.filteredMap = new Map(
      [...this.designationCabMap].filter(key => {
        if (key[0].toLowerCase().includes(input.toLowerCase())) {
          return key;
        }
      }
      ));
  }

  selectDesignationCity(event) {
    if (this.alteredList.length == 0) {
      this.firstCity = event.label;
      this.selectedCity = event.label;
      this.bookingViewService.cityName.next(event.label);
      this.setVehicleDesignationList();
    }
    else { this.showSaveConfigWarning = true; }
  }

  setInitialConditions() {
    this.alteredList = [];
    this.firstCity = this.cities[0].label;
    this.selectedCity = this.firstCity;
    this.alteredDesignationCabs = [];
    this.searchInput = '';
    this.setVehicleDesignationList();
  }

  handleCheckboxClick(checkedItem: any){
    const designation = checkedItem.name;
    this.filteredMap.set(designation, 
      {
        selectedVehicles: this.filteredMap.get(designation).selectedVehicles,
        hasHighCapacityAccess: checkedItem.value 
      });
    const index = this.alteredList.findIndex(element => element.designation == designation);
    if (index === -1) {
      this.alteredList.push({
        designation,
        selectVehicleTypes: this.filteredMap.get(designation).selectedVehicles.map((item: any)=>item.value),
        hasHighCapacityAccess: checkedItem.value
      });
    }
    else {
      this.alteredList[index].hasHighCapacityAccess = checkedItem.value;
    }
  }

  openDefineCabsDialog(){
    this.dialogRef = this.dialog.open(DefineCabsDialogComponent, {
      data: this.availableCabTypesList,
      panelClass: 'custom-container',
      width: '475px',
    });

    this.dialogRef.componentInstance.highCapVehiclesConfigEmitter.subscribe((res)=>{
      this.toastMsg = 'Cab type(s) successfully defined as high capacity';
      this.showSuccessToast = true;
      setTimeout(()=>{this.showSuccessToast = false}, 3000);
      this.setVehicleDesignationList()
    });
  }

  discardChanges(city) {
    this.showSaveConfigWarning = false;
    this.selectedCity = city;
    this.bookingViewService.cityName.next(city);
    this.setVehicleDesignationList();
  }

  onSave() {
    if (this.alteredList.length !== 0) {
      this.bookingViewService.saveDbvaConfig(this.alteredList, this.selectedCity).subscribe(res => {
        if (res == 'Request submitted successfully') {
          this.toastMsg = res;
          this.showSuccessToast = true;
          setTimeout(() => { this.showSuccessToast = false; }, 3000);
        }
        this.setVehicleDesignationList();
      });
    }
    this.showSaveConfigWarning = false;
    this.alteredList = [];
  }

  makeButtonSubmitEnable() {
    this.showSaveConfigWarning = false;
    this.onSave();
  }
}
